"use strict";

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License. See License.txt in the project root for license information.
var _classCallCheck = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("C:/__w/1/s/ManagedLabs/src/Client/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var constants_1 = require("./util/constants");
var msRest = require("ms-rest-js");
var LroStates = constants_1.default.LongRunningOperationStates;
/**
 * @class
 * Initializes a new instance of the PollingState class.
 */
var PollingState = /*#__PURE__*/function () {
  function PollingState(resultOfInitialRequest) {
    var retryTimeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 30;
    _classCallCheck(this, PollingState);
    /**
     * @param {number} [retryTimeout] - The timeout in seconds to retry on intermediate operation results. Default Value is 30.
     */
    this.retryTimeout = 30;
    this.resultOfInitialRequest = resultOfInitialRequest;
    this.retryTimeout = retryTimeout;
    this.updateResponse(resultOfInitialRequest.response);
    this.request = resultOfInitialRequest.request;
    // Parse response.body & assign it as the resource.
    try {
      if (resultOfInitialRequest.bodyAsText && resultOfInitialRequest.bodyAsText.length > 0) {
        this.resource = JSON.parse(resultOfInitialRequest.bodyAsText);
      } else {
        this.resource = resultOfInitialRequest.bodyAsJson;
      }
    } catch (error) {
      var deserializationError = new msRest.RestError("Error \"".concat(error, "\" occurred in parsing the responseBody \" +\n        \"while creating the PollingState for Long Running Operation- \"").concat(resultOfInitialRequest.bodyAsText, "\""));
      deserializationError.request = resultOfInitialRequest.request;
      deserializationError.response = resultOfInitialRequest.response;
      throw deserializationError;
    }
    switch (this.response.status) {
      case 202:
        this.status = LroStates.InProgress;
        break;
      case 204:
        this.status = LroStates.Succeeded;
        break;
      case 201:
        if (this.resource && this.resource.properties && this.resource.properties.provisioningState) {
          this.status = this.resource.properties.provisioningState;
        } else {
          this.status = LroStates.InProgress;
        }
        break;
      case 200:
        if (this.resource && this.resource.properties && this.resource.properties.provisioningState) {
          this.status = this.resource.properties.provisioningState;
        } else {
          this.status = LroStates.Succeeded;
        }
        break;
      default:
        this.status = LroStates.Failed;
        break;
    }
  }
  /**
   * Update cached data using the provided response object
   * @param {Response} [response] - provider response object.
   */
  return _createClass(PollingState, [{
    key: "updateResponse",
    value: function updateResponse(response) {
      this.response = response;
      if (response && response.headers) {
        var asyncOperationHeader = response.headers.get("azure-asyncoperation");
        var locationHeader = response.headers.get("location");
        if (asyncOperationHeader) {
          this.azureAsyncOperationHeaderLink = asyncOperationHeader;
        }
        if (locationHeader) {
          this.locationHeaderLink = locationHeader;
        }
      }
    }
    /**
     * Gets timeout in milliseconds.
     * @returns {number} timeout
     */
  }, {
    key: "getTimeout",
    value: function getTimeout() {
      if (this.retryTimeout || this.retryTimeout === 0) {
        return this.retryTimeout * 1000;
      }
      if (this.response) {
        var retryAfter = this.response.headers.get("retry-after");
        if (retryAfter) {
          return parseInt(retryAfter) * 1000;
        }
      }
      return 30 * 1000;
    }
    /**
     * Returns long running operation result.
     * @returns {msRest.HttpOperationResponse} HttpOperationResponse
     */
  }, {
    key: "getOperationResponse",
    value: function getOperationResponse() {
      var result = new msRest.HttpOperationResponse(this.request, this.response);
      if (this.resource && typeof this.resource.valueOf() === "string") {
        result.bodyAsText = this.resource;
        result.bodyAsJson = JSON.parse(this.resource);
      } else {
        result.bodyAsJson = this.resource;
        result.bodyAsText = JSON.stringify(this.resource);
      }
      return result;
    }
    /**
     * Returns an Error on operation failure.
     * @param {Error} err - The error object.
     * @returns {msRest.RestError} The RestError defined in the runtime.
     */
  }, {
    key: "getRestError",
    value: function getRestError(err) {
      var errMsg;
      var errCode = undefined;
      var error = new msRest.RestError("");
      error.request = msRest.stripRequest(this.request);
      error.response = this.response;
      var parsedResponse = this.resource;
      if (err && err.message) {
        errMsg = "Long running operation failed with error: \"".concat(err.message, "\".");
      } else {
        errMsg = "Long running operation failed with status: \"".concat(this.status, "\".");
      }
      if (parsedResponse) {
        if (parsedResponse.error && parsedResponse.error.message) {
          errMsg = "Long running operation failed with error: \"".concat(parsedResponse.error.message, "\".");
        }
        if (parsedResponse.error && parsedResponse.error.code) {
          errCode = parsedResponse.error.code;
        }
      }
      error.message = errMsg;
      if (errCode) error.code = errCode;
      error.body = parsedResponse;
      return error;
    }
  }]);
}();
exports.default = PollingState;